import { render } from "./edit.vue?vue&type=template&id=1a69a6b8"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/people/people/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a69a6b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a69a6b8', __exports__)) {
    console.log('reload')
    api.reload('1a69a6b8', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=1a69a6b8", () => {
    console.log('re-render')
    api.rerender('1a69a6b8', render)
  })

}


export default __exports__